import { EXPRESS_API } from 'configs/api/expressApi';

import { QueryKey, useQuery, UseQueryOptions } from 'react-query';
import { qrVideosKeys } from './qrVideosKeys';
import { useToastError } from 'lib/hooks';

export interface QrVideosResponse {
  count: number;
  qrVideos: QrVideo[];
}

export interface QrVideo {
  qrType: number;
  videoId: number;
  designId: number;
  templateLinks: number;
  overlayUrlId: number;
  url: string;
  qrId: number;
  userId: number;
  customerId: number;
  title: string;
  qrUrl: string;
  itemType: null | string;
  video: null;
  template: Template;
  cta: Cta | null;
  overlay: Overlay | null;
  qrHits: QrHit[];
}

export interface Cta {
  createdAt: null;
  updatedAt: null;
  id: number;
  userId: number;
  customerId: number;
  company: number;
  title: string;
  defaultLinks: number;
}

export interface Overlay {
  id: number;
  userId: number;
  customerId: number;
  title: string;
  url: string;
  defaultflag: number;
  type: null;
  itemType: null;
  fileTitle: null;
  fileThumbnail: null;
}

export interface QrHit {
  qrHitId: number;
  qrId: number;
  videoId: number;
  designId: number;
  templateLinks: number;
  overlayUrlId: number;
  url: string;
  timestamp: string;
}

export interface Template {
  isArchived: number;
  id: number;
  title: string;
  filename: string;
  customerId: number;
  thumbnail: string;
  numberOfLinks: number;
  typeId: number;
  resellerId: number;
  responsive: number;
  hidden: number;
  landingPageId: number | null;
}

interface QueryListParams {
  page?: number;
  size?: number;
  search?: string;
  sort?: string;
}

const getQRVideos = async ({
  page = 0,
  size = 10,
  search,
  sort,
}: QueryListParams): Promise<QrVideosResponse> => {
  const start = page * size;
  const params = {
    start,
    limit: size,
    search: search,
    sort: sort,
  };
  const response = await EXPRESS_API.get(`/qr-videos`, { params });
  return response.data;
};

export const useQrVideosQuery = ({
  options,
  params,
}: {
  options?: Omit<
    UseQueryOptions<QrVideosResponse, Error, QrVideosResponse, QueryKey>,
    'queryKey' | 'queryFn'
  >;
  params: QueryListParams;
}) => {
  const { showError } = useToastError();
  return useQuery<QrVideosResponse, Error>(
    qrVideosKeys.all(),
    () => getQRVideos(params),
    {
      ...options,
      onError: err =>
        showError(
          err,
          'Unable to retrieve QR Codes at the moment. Please try again in a few minutes.'
        ),
    }
  );
};
